import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03c1e662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fz-14 lh-36" }
const _hoisted_2 = { class: "fz-14 lh-36" }
const _hoisted_3 = { class: "fixed print-box" }
const _hoisted_4 = { id: "printBox" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "font-blod",
  style: {"min-width":"30mm","margin-top":"1mm"}
}
const _hoisted_7 = { class: "title-name flex-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "库区：", -1))
const _hoisted_9 = { class: "one-row" }
const _hoisted_10 = {
  class: "title-name flex-row",
  style: {"margin-top":"0.5mm"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "库位：", -1))
const _hoisted_12 = { class: "flex-1" }

import { ref, watch, getCurrentInstance } from 'vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'PrintWarehouseLocationLabelBtn',
  props: {
		text: {
			type: String,
			default: "",
		},
		SelectArr: {
			type: Array,
			default: function () {
				return []
			},
		}
	},
  setup(__props) {

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const PrintArr = ref<any>([]);
	const print = ref<any>({
		id: 'printBox',//这里的id就是上面我们的打印区域id，实现指哪打哪
		popTitle: '', // 打印配置页上方的标题
		extraCss: "", // 打印可引入外部的一个 css 文件
		extraHead: ' ', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
		preview: false, // 是否启动预览模式，默认是false
		previewTitle: ' ', // 打印预览的标题
		previewPrintBtnLabel: ' ', // 打印预览的标题下方的按钮文本，点击可进入打印
		zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
	});

	watch(() => props.SelectArr, (n : any) => {
		PrintArr.value = n;
	}, {
		immediate: true,
	});

	const StartPrint = () => {
		proxy.$message.error("请选择库位");
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock("div", null, [
    (PrintArr.value.length > 0)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "print-btn",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(__props.text), 1)
          ]),
          _: 1
        })), [
          [_directive_print, print.value]
        ])
      : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "print-btn",
          type: "primary",
          onClick: StartPrint
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1)
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(PrintArr.value, (v, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex-column-center-center",
            style: {"page-break-after":"always","height":"24mm"},
            key: i
          }, [
            _createElementVNode("img", {
              class: "qrcode_1_1",
              src: v.barcode_url,
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(v.area_name), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(v.shelves_sn) + "-" + _toDisplayString(v.rows < 10 ? `0${v.rows}` : v.rows) + "-" + _toDisplayString(v.columns < 10 ? `0${v.columns}` : v.columns), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})